import { TState } from 'redux/config/root-types'
import { call, put, select } from 'redux-saga/effects'
import { Actions_Parkings } from 'redux/modules/parkings/Actions'
import { RequestMethods } from 'utils/axios/methods'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { TTableFilterRedux } from 'utils/helpers/table'
import { PayloadAction } from '@reduxjs/toolkit'
import { AxiosRequestConfig } from 'axios'

const { download } = RequestMethods()

export default function* SagaWorker_LoadAllParkingsXls(action?: PayloadAction<TTableFilterRedux>) {
  yield put(Actions_Parkings.store.showLoader())

  try {
    const getFilter = (state: TState) => state.parkings.filter
    const filter: ReturnType<typeof getFilter> = yield select(getFilter)

    const formData = {
      organizationName: filter.organizationName === null ? undefined : filter.organizationName,
      parkingName: filter.parkingName === null ? undefined : filter.parkingName,
      parkingImei: filter.imei === null ? undefined : filter.imei,
      showDrainedBattery: filter.batteryCharge === null ? undefined : filter.batteryCharge,
      hideFreeStations: filter.hideFreeStations === null ? undefined : filter.hideFreeStations,
      hideNoFreeStations: filter.hideNoFreeStations === null ? undefined : filter.hideNoFreeStations,
      hideOneFreeStation: filter.hideOneFreeStation === null ? undefined : filter.hideOneFreeStation,
      orderBy: filter.orderBy,
      sorting: filter.sorting,
      isVirtual: filter.isVirtual,
    }

    const config = {
      responseType: 'blob',
    } as AxiosRequestConfig

    yield call(async () => download('/parking/xlsx', formData, config, ' parkings.xlsx'))
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_Parkings.store.hideLoader())
  }
}
